import { render, staticRenderFns } from "./AssistantsView.vue?vue&type=template&id=798add28&scoped=true&"
import script from "./AssistantsView.vue?vue&type=script&lang=js&"
export * from "./AssistantsView.vue?vue&type=script&lang=js&"
import style0 from "./AssistantsView.vue?vue&type=style&index=0&id=798add28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798add28",
  null
  
)

export default component.exports